<script lang="ts" setup>
import { formatDate, type DateOptions } from '@/helpers/formating'

interface GwDateItemProps {
  item: string
  dateOptions?: DateOptions
  tstPrefix?: string
}

withDefaults(defineProps<GwDateItemProps>(), {
  dateOptions: () => ({
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: false,
    minute: false,
    second: false,
    timeZoneName: undefined,
  }),
  tstPrefix: 'date_item',
})
</script>
<template>
  {{ formatDate(item, dateOptions) }}
</template>
